import React, { FC } from 'react'

interface LeftRightEarProps {
    ear: "r" | "l"
}
const LeftRightEar: FC<LeftRightEarProps> = ({ ear }) => {
    return (
        <div>
            <span style={{ opacity: ear === "l" ? 1 : 0.5 }}>L</span>/<span style={{ opacity: ear === "r" ? 1 : 0.5 }}>R</span>
        </div >
    )
}

export default LeftRightEar